module.exports = __webpack_public_path__ + "img/didriksons_country_select.bb896383.jpg";